export const PROJECTS_SCHEDULING_FILTER_STRING = 'projects_scheduling_filters';
export const PROJECTS_SCHEDULING_EYE_OPTIONS_STORAGE_KEY = 'canvas-project-scheduling-layout-options-v0.3';
export const PROJECTS_SCHEDULING_UTILIZATION_FORMAT_STORAGE_KEY = 'projectScheduling_utilizationFormat';
export const PROJECTS_SCHEDULING_VISUALIZATION_MODE_STORAGE_KEY = 'projectScheduling_visualizationMode';
